import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { company } from '@/mocks/site';

type CtaSectionProps = {
  title?: string;
  accent?: string;
  description?: string;
};

export default function CtaSection({
  title = 'Un ouvrage à réaliser ?',
  accent = 'Commençons par un échange.',
  description = "Envoyez vos plans, vos photos ou simplement votre besoin. Nous revenons vers vous avec une première lecture technique et une proposition adaptée.",
}: CtaSectionProps) {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20precision%20weld%20seam%20on%20thick%20steel%20plate%2C%20cool%20navy%20blue%20industrial%20lighting%20with%20a%20single%20warm%20orange%20glow%20reflecting%20on%20the%20metal%2C%20dark%20anthracite%20textured%20background%2C%20minimal%20industrial%20macro%20photography%2C%20technical%20and%20clean%2C%20high%20detail&width=1600&height=800&seq=sgsctic-cta-navy-weld&orientation=landscape&nocache=true"
          alt="Texture d'acier soudé en gros plan"
          title="Projet industriel SGSCTIC"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/90 to-foreground-950/50" />
      </div>

      <div className="container-wide relative z-10 py-20 md:py-28">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-accent-500" />
              <span className="label-mono text-accent-400">Parlons de votre projet</span>
            </div>
            <h2 className="display-title mt-6 text-5xl leading-[0.92] text-background-50 sm:text-6xl lg:text-7xl">
              {title}
              <br />
              <span className="text-accent-400">{accent}</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-background-200">
              {description}
            </p>
          </Reveal>

          <Reveal delay={150}>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="btn-shine flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-foreground-950 transition-colors hover:bg-accent-400"
              >
                Demander un devis
                <i className="ri-arrow-right-up-line text-base" />
              </Link>
              <a
                href={company.phoneHref}
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
              >
                <i className="ri-phone-line text-base" />
                {company.phone}
              </a>
            </div>
          </Reveal>

          <Reveal delay={250}>
            <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 border-t border-background-50/15 pt-7 text-sm text-background-300">
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" />
                {company.address}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                {company.email}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                {company.hours}
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}